// sensei-app/client/widgets/PlatformVitalsWidget.widget.js
export default {
    name: "PlatformVitalsWidget",
    type: "MultiDisplayWidget",
    description: "Displays high-level statistics for the entire platform.",
    roles: ["admin"], // This widget is for Platform Administrators
    widget: {
        title: "Platform Vitals",
        size: "large",

        dataProvider: {
            main: {
                rpc: "AdminPlatformRpc.getPlatformStats"
                // RPC returns a single object { totalStudents: ..., ... }, so no transform needed.
            }
        },

        items: [
            { label: "Total Students", valueField: "totalStudents", icon: "bi bi-person-fill" },
            { label: "Total Parents", valueField: "totalParents", icon: "bi bi-people" },
            { label: "Total Courses", valueField: "totalCourses", icon: "bi bi-journal-album" },
            { label: "Active Sessions", valueField: "activeSessions", icon: "bi bi-activity" }
        ]
    }
};